<template>
  <div>
    <Hero/>
    <Features/>
    <ContentWithImage sectionName="answer-a-few-questions-and-get-recommended-documents" text-size="sm" justify-center image-order="1" image-order-sm="0" h2/>
    <ContentWithImage sectionName="easily-customize-our-ready-made-documents" text-size="sm" justify-center image-order="0" image-order-sm="0" h2/>
    <background-wrapper :src="routeNameKebab + '/fullscreen-image_or-add-your-own'" ext="png">
      <div class="or-add-your-own">
        <ContentWithImage sectionName="or-add-your-own" text-size="sm" justify-center image-order="2" image-order-sm="2" margin="0px 0px -190px 0px" h2/>
      </div>
    </background-wrapper>
    <ContentWithImage class="keep-your-manual" sectionName="keep-your-manual-up-to-date" text-size="sm" justify-center image-order="0" image-order-sm="0" h2/>
    <RequestDemo/>
    <Tools/>
    <LetsGet/>
  </div>
</template>

<script>
import { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo } from '@/components/ui/products'

export default {
  name: 'PolicyManualWizard',
  components: { Hero, Tools, LetsGet, Features, ContentWithImage, RequestDemo },
  computed: {
    routeNameKebab: app => app.$toKebabCase(app.$route.name)
  }
}
</script>

<style lang="sass">
.keep-your-manual
  img
    width: 520px!important
    +media-breakpoint-down(sm)
      width: 460px!important
    +media-breakpoint-down(xs)
      width: 80%!important
</style>

<style lang="sass" scoped>
.or-add-your-own
  padding-bottom: 250px
</style>



// WEBPACK FOOTER //
// src/components/products/PolicyManualWizard/PolicyManualWizard.vue